/**
 * Smart App Banner - dynamically sets the apple-itunes-app meta tag
 * to enable "Open in App" functionality on iOS Safari with correct deep link
 */
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const APP_STORE_ID = '1465156373';

export const SmartAppBanner: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const isAuthPage = location.pathname.startsWith('/auth');
    const returnTo = searchParams.get('returnTo');
    const intendedPath = isAuthPage && returnTo ? returnTo : `${location.pathname}${location.search}`;
    const fullUrl = `https://coach.kinastic.com${intendedPath}`;

    // Find or create the meta tag
    let metaTag = document.querySelector('meta[name="apple-itunes-app"]') as HTMLMetaElement;
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.name = 'apple-itunes-app';
      document.head.appendChild(metaTag);
    }

    // Set the content with app-id and app-argument
    metaTag.content = `app-id=${APP_STORE_ID}, app-argument=${fullUrl}`;

    return () => {
      // Cleanup not needed - we want to keep the tag
    };
  }, [location.pathname, searchParams]);

  return null;
};
